import React from "react";
import DonutList from "../../../../components/donutList/donutList";
import { actionCreators } from "../redux/attendanceSagas";
import { useDispatch, useSelector } from "react-redux";

const ClassByType = () => {
  const dispatch = useDispatch();
  const classByTypeAttendance = useSelector((state) => state.attendance.classByTypeAttendance);
  const allClassesByType = useSelector((state) => state.attendance.allClassesByType);
  const classByTypeAttendanceCheckedMax = useSelector(
    (state) => state.attendance.classByTypeAttendanceCheckedMax
  );

  return (
    <DonutList
      title="Select Classes"
      module=".widget-wrapper.attendanceWidget"
      selectHeight={350}
      modalHeight={450}
      modalWidth={350}
      maxDonuts={3}
      maxChecked={classByTypeAttendanceCheckedMax}
      modalPositionRight
      donutValues={classByTypeAttendance.slice(0, 3).map((rev) => ({
        ...rev,
        value: rev.percentage * 100,
        type: rev.name,
        fontSize: 24,
        hasMinusButton: true,
        attended: rev.totalAttendees,
        totalAttended: rev.totalPotentialAttendees,
        growth: rev.percentChange,
        toolTip: "Percentage change from previous month",
        centerToolTip: "Class Utilization",
        customTitleStyle: "title-height-60"
      }))}
      groupValues={allClassesByType.map(({ name, id }) => ({
        label: name,
        value: id
      }))}
      onMinusButtonClick={(donutProps) => dispatch(actionCreators.removeClassCategory(donutProps))}
      itemWasChecked={(items) => {
        let keys = Object.keys(items);
        let filtered = keys.filter((key) => items[key]);
        const maxChecked = filtered.length >= 3 && true;
        return dispatch(actionCreators.setClassTypesChecked({ filtered, maxChecked }));
      }}
      onSubmit={(result) => {
        const revenueTypeIds = Object.keys(result.checkedGroups);
        const revenueTypeName = result.groupName;
        return dispatch(actionCreators.addClassChart({ revenueTypeIds, revenueTypeName }));
      }}
    />
  );
};

export default ClassByType;
